import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Spinner } from "@/components/ui/spinner";
import { useState } from "react";

interface DeleteConfirmationModelProps {
  onDelete: () => Promise<void> | void;
  open: boolean;
  onClose: () => void;
}

export const DeleteConfirmationModel = ({
  open,
  onClose,
  onDelete,
}: DeleteConfirmationModelProps) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      await onDelete();
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(o) => !o && !isDeleting && onClose()}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Confirm MFA Deletion</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete your current MFA method? Geoscape
            recommends you protect your account with MFA. You can setup MFA
            again later from your account settings.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col gap-2 sm:flex-col">
          <Button
            variant="destructive"
            className="w-full"
            onClick={handleDelete}
            disabled={isDeleting}
          >
            {isDeleting ? <Spinner /> : "Delete MFA"}
          </Button>
          <Button
            variant="outline"
            className="w-full"
            onClick={onClose}
            disabled={isDeleting}
          >
            Cancel
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
